import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { FilterProfileService } from '@services/filter-profile.service';
import { LogService } from '@services/log.service';
import { capitalizeFirstLetter } from '@utils/utils';
import { BehaviorSubject } from 'rxjs';

export type ProfileType = 'Tank' | 'Filter';

@Component({
  selector: 'app-view-filter-profile-details-pop-up',
  templateUrl: './view-filter-profile-details-pop-up.component.html',
  styleUrls: ['./view-filter-profile-details-pop-up.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewFilterProfileDetailsPopUpComponent {
  @Input() filterProfileId: number;
  @Input() linkText: string = 'View';
  filterProfile: any;

  isLoading$ = new BehaviorSubject<boolean>(true);
  isLoading = this.isLoading$.asObservable();

  filterModel: any;

  get filters() {
    return Object.keys(this.filterModel);
  }

  constructor(
    private _fps: FilterProfileService,
    private _cdr: ChangeDetectorRef,
    private _logger: LogService,
  ) {}

  onPopupOpen() {
    this.loadFilterProfile();
  }

  formatFilterName(filterColumnName: string) {

    switch(filterColumnName) {
      default:
        return `Column.${capitalizeFirstLetter(filterColumnName)}`;
    }

  }

  private loadFilterProfile() {
    this.isLoading$.next(true);
    this._cdr.markForCheck();

    this._fps.getFilterProfile(this.filterProfileId).subscribe((fp) => {
      this.filterProfile = fp;
      this.filterModel = JSON.parse(fp.tankFilterJson);
      const geo = this.filterModel['geoLocationFilter'];
      if (geo?.values?.length > 0) {
        const locationId = Number(geo.values[0]);
        if(!isNaN(locationId) && locationId > 0 && fp.locationName){
          this.filterModel['geoLocationFilter'] = {
            filterType: 'set',
            values: [fp.locationName]
          };
        }
      }
      this.isLoading$.next(false);
      this._cdr.markForCheck();
      this._logger.info(
        'Filter profile loaded',
        this.filterProfile,
        this.filterModel,
      );
    });
  }
}
